const Counter = ({ heading, counterData, counterDatasubtext }) => {



    return (


        <div className='counter-container'>

            <p className='small-text'>{heading || 'No heading passed'}</p>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', alignItems: 'center' }}>

                <h2>{counterData ? Number(counterData).toFixed(2) : 'Not Set'}</h2>
                <p className='small-text'>{counterDatasubtext || 'No subtext passed'}</p>

            </div>


        </div>


    );
}

export default Counter;